module.exports = __webpack_public_path__ + "static/media/duetigli-sangiovese-marche.9fccfb98.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/duetigli-sangiovese-marche.png
// module id = 794
// module chunks = 0